import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AgenxCircleButtonComponent } from "../circle-button/circle-button.component";
import { OfflineService } from '../../../../services/offline.service';

@Component({
  selector: 'agenx-card',
  standalone: true,
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  imports: [NgClass, AgenxCircleButtonComponent],
})
export class AgenxCardComponent implements OnInit {
  @Input() title: string = 'Card title';
  @Input() borderTopLess: boolean = false;
  @Input() borderBottomLess: boolean = false;
  @Input() button: string | null = null;
  @Input() show: boolean | null = null;
  @Input() line: boolean = true;
  @Output() buttonClick = new EventEmitter<boolean>();

  currentClasses: Record<string, boolean> = {};
  icon_src = '';
  icon_excl = '';
  icon_chevron = '';

  constructor(public offlineSrv: OfflineService) {}

  /**
   * Function to set the current classes of the card
   *
   * @memberof AgenxCardComponent
   */
  setCurrentClasses() {
    this.currentClasses = {
      'agenx-card--less-top': this.borderTopLess,
      'agenx-card--less-bottom': this.borderBottomLess,
    };
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change['show']) {
      this.show = change['show'].currentValue;
      this.show === true
        ? (this.icon_chevron = this.offlineSrv.loadAssetInLocal('icon-up.svg'))
        : (this.icon_chevron =
            this.offlineSrv.loadAssetInLocal('icon-down.svg'));
    }
    if (change['borderTopLess']) {
      this.borderTopLess = change['borderTopLess'].currentValue;
      this.setCurrentClasses()
    }
  }

  ngOnInit(): void {
    this.icon_src = this.offlineSrv.loadAssetInLocal('Icon_comeback2.svg');
    this.setCurrentClasses();
  }

  onButtonClick(): void {
    this.buttonClick.emit(true);
  }

  onShow(): void {
    this.show = !this.show;
    this.show === true ?
      this.icon_chevron = this.offlineSrv.loadAssetInLocal('icon-up.svg') :
      this.icon_chevron = this.offlineSrv.loadAssetInLocal('icon-down.svg')
  };
}
